/**
 * Cloud-aware infra defaults — same idea as BUS-SEO-DataLoader / BUS-Commons:
 * GCP deploy → GCP Grounds hosts; AWS/ECS → legacy AWS hosts (origin/release .env).
 * Explicit env (Helm / dotenv) always wins when set.
 * No Secrets Manager on AWS — renderer has no DB secrets (avoids ECS CredentialsError).
 */

const { isGcpDeployment, isNonProdEnv } = require('./gcpSecretConfig');

const GCP_KAFKA_NPD = 'kafka.db-npd.mmt.internal:9092';
const GCP_KAFKA_PRD = 'kafka-grd.db-prd.mmt.internal:9092';
const AWS_KAFKA_PROD = 'kafka-data.mmt.mmt:9092';
const AWS_KAFKA_QA = '172.16.47.208:9092';

const GCP_AEROSPIKE_NPD = 'aspk-grd.db-npd.mmt.internal:3000';
const GCP_AEROSPIKE_PRD =
  'aerospike-grd-bus-1.db-prd.mmt.internal,aerospike-grd-bus-2.db-prd.mmt.internal,aerospike-grd-bus-3.db-prd.mmt.internal,aerospike-grd-bus-4.db-prd.mmt.internal,aerospike-grd-bus-5.db-prd.mmt.internal';
const AWS_AEROSPIKE_PROD =
  'aerospike-grounds-busseo-1.mmt.mmt,aerospike-grounds-busseo-2.mmt.mmt,aerospike-grounds-busseo-3.mmt.mmt';
const AWS_AEROSPIKE_QA = '172.16.211.119:3000';

const GCP_AEROSPIKE_NS_NPD = 'test_disk_ns';
const GCP_AEROSPIKE_NS_PRD = 'ns_256';
const AWS_AEROSPIKE_NS_PROD = 'ns_256';
const AWS_AEROSPIKE_NS_QA = 'test_disk_ns';

const GCP_DATA_LOADER_NPD = 'http://bus-seo-dataloader.npd.mmt.internal';
const GCP_DATA_LOADER_PRD = 'http://bus-seo-dataloader.prd.mmt.internal';
const AWS_DATA_LOADER = 'http://bus-seo-data-loader.ecs.mmt';

const GCP_GENIE_NPD = 'http://bus-genie.npd.mmt.internal';
const GCP_GENIE_PRD = 'http://bus-genie.prd.mmt.internal';
const AWS_GENIE = 'http://bus-genie.ecs.mmt';

const resolveKafkaHost = () => {
  if (process.env.KAFKA_HOST) {
    return process.env.KAFKA_HOST;
  }
  if (isGcpDeployment()) {
    return isNonProdEnv() ? GCP_KAFKA_NPD : GCP_KAFKA_PRD;
  }
  return isNonProdEnv() ? AWS_KAFKA_QA : AWS_KAFKA_PROD;
};

const resolveAerospikeServer = () => {
  if (process.env.AEROSPIKE_SERVER) {
    return process.env.AEROSPIKE_SERVER;
  }
  if (isGcpDeployment()) {
    return isNonProdEnv() ? GCP_AEROSPIKE_NPD : GCP_AEROSPIKE_PRD;
  }
  return isNonProdEnv() ? AWS_AEROSPIKE_QA : AWS_AEROSPIKE_PROD;
};

const resolveAerospikeNamespace = () => {
  if (process.env.AEROSPIKE_NAMESPACE) {
    return process.env.AEROSPIKE_NAMESPACE;
  }
  if (isGcpDeployment()) {
    return isNonProdEnv() ? GCP_AEROSPIKE_NS_NPD : GCP_AEROSPIKE_NS_PRD;
  }
  return isNonProdEnv() ? AWS_AEROSPIKE_NS_QA : AWS_AEROSPIKE_NS_PROD;
};

const resolveDataLoaderUrl = () => {
  if (process.env.DATA_LOADER_URL) {
    return process.env.DATA_LOADER_URL;
  }
  if (isGcpDeployment()) {
    return isNonProdEnv() ? GCP_DATA_LOADER_NPD : GCP_DATA_LOADER_PRD;
  }
  return AWS_DATA_LOADER;
};

const resolveBusGenieFqdn = () => {
  if (process.env.BUS_GENIE_FQDN) {
    return process.env.BUS_GENIE_FQDN;
  }
  if (isGcpDeployment()) {
    return isNonProdEnv() ? GCP_GENIE_NPD : GCP_GENIE_PRD;
  }
  return AWS_GENIE;
};

const applyCloudDefaultsToEnv = (raw) => {
  if (!raw || typeof raw !== 'object') {
    return raw;
  }
  raw.KAFKA_HOST = resolveKafkaHost();
  raw.AEROSPIKE_SERVER = resolveAerospikeServer();
  raw.AEROSPIKE_NAMESPACE = resolveAerospikeNamespace();
  raw.DATA_LOADER_URL = resolveDataLoaderUrl();
  raw.BUS_GENIE_FQDN = resolveBusGenieFqdn();
  return raw;
};

const logResolvedInfra = () => {
  // eslint-disable-next-line no-console
  console.log('Cloud deploy:', isGcpDeployment() ? 'GCP' : 'AWS');
  // eslint-disable-next-line no-console
  console.log('Resolved KAFKA_HOST:', resolveKafkaHost());
  // eslint-disable-next-line no-console
  console.log('Resolved AEROSPIKE_SERVER:', resolveAerospikeServer());
  // eslint-disable-next-line no-console
  console.log('Resolved AEROSPIKE_NAMESPACE:', resolveAerospikeNamespace());
  // eslint-disable-next-line no-console
  console.log('Resolved DATA_LOADER_URL:', resolveDataLoaderUrl());
  // eslint-disable-next-line no-console
  console.log('Resolved BUS_GENIE_FQDN:', resolveBusGenieFqdn());
};

module.exports = {
  resolveKafkaHost,
  resolveAerospikeServer,
  resolveAerospikeNamespace,
  resolveDataLoaderUrl,
  resolveBusGenieFqdn,
  applyCloudDefaultsToEnv,
  logResolvedInfra,
};
